import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';
import { Box, Container, Paper, Typography } from '@mui/material';
import { useDispatch } from 'react-redux';
import { Link } from 'react-router-dom';

import { authActions } from '../store';

const NotFound = () => {
  const dispatch = useDispatch();
  const { logout } = useAuth0();

  function handleClick(e: any) {
    e.preventDefault();
    logout({ logoutParams: { returnTo: window.location.origin } });
    dispatch(authActions.logout());
  }
  return (
    <>
      <Box>
        <Container maxWidth="sm" sx={{ height: '100vh', display: 'flex', alignItems: 'center' }}>
          <Paper
            elevation={6}
            sx={{
              display: 'flex',
              flexDirection: 'column',
              flexGrow: 1,
              height: 200,
              p: 5,
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <Typography variant="h5" sx={{ fontWeight: 'bold' }}>
              You Need To Be Invited To Use This App{' '}
              <Link to={'/'} onClick={(e) => handleClick(e)}>
                Click To Return Home
              </Link>
            </Typography>
          </Paper>
        </Container>
      </Box>
    </>
  );
};

export default NotFound;
